"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequest = void 0;
const Toast_1 = require("./../modules/toast/Toast");
const config_1 = require("../config");
const mapper_1 = require("../helpers/mapper");
const i18next_1 = __importDefault(require("i18next"));
class HttpRequest {
    constructor() {
        this.apiUrl = config_1.config.backend.corePath;
        this.storagePath = config_1.config.backend.storagePath;
    }
    get(url, token = null) {
        const headers = new Headers();
        if (token)
            headers.append('Authorization', `Bearer ${token}`);
        const options = {
            method: 'GET',
            headers: headers
        };
        return fetch(this.apiUrl + url, options).then(this.handleResponse).catch(this.handleError);
    }
    getStorage(url, token = null, ignoreError = false) {
        return __awaiter(this, void 0, void 0, function* () {
            url = this.storagePath + url;
            const headers = new Headers();
            if (token)
                headers.append('Authorization', `Bearer ${token}`);
            const options = {
                method: 'GET',
                headers: headers
            };
            if (ignoreError) {
                return fetch(url, options).then(this.handleBlobImageResponse);
            }
            return fetch(url, options).then(this.handleBlobImageResponse).catch(this.handleError);
        });
    }
    postStorage(url, data, token = null) {
        return __awaiter(this, void 0, void 0, function* () {
            url = this.storagePath + url;
            const headers = new Headers();
            if (token)
                headers.append('Authorization', `Bearer ${token}`);
            const options = {
                method: 'POST',
                headers: headers,
                body: data
            };
            return fetch(url, options).then(this.handleResponse).catch(this.handleError);
        });
    }
    post(url, body, token = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token)
            headers.append('Authorization', `Bearer ${token}`);
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        };
        return fetch(this.apiUrl + url, options).then(this.handleResponse).catch(this.handleError);
    }
    put(url, body, token = null) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if (token)
            headers.append('Authorization', `Bearer ${token}`);
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return fetch(this.apiUrl + url, options).then(this.handleResponse).catch(this.handleError);
    }
    delete(url, token = null) {
        const headers = new Headers();
        if (token)
            headers.append('Authorization', `Bearer ${token}`);
        const options = {
            method: 'DELETE',
            headers: headers
        };
        return fetch(this.apiUrl + url, options).then(this.handleResponse).catch(this.handleError);
    }
    handleResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield response.json();
                if (!response.ok) {
                    return Promise.reject((data && data.message) || response.statusText);
                }
                const mapedData = (new mapper_1.Mapper).mapToCamel(data);
                return mapedData;
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    handleBlobImageResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield response.blob();
                const url = URL.createObjectURL(data);
                if (!response.ok) {
                    return Promise.reject((data && data.message) || response.statusText);
                }
                return url;
            }
            catch (error) {
                return Promise.reject(error);
            }
        });
    }
    handleError(error) {
        Toast_1.Toast.create('error', i18next_1.default.t("ERROR_HAPPENED"), 3000);
        return Promise.reject(error);
    }
}
exports.HttpRequest = HttpRequest;
